import { defineStore } from 'pinia';
import notificationsApi from '../api/notifications';
import { getSocket } from '../api/socket';

export const useNotificationStore = defineStore('notifications', {
  state: () => ({
    items: [],
    unreadCount: 0,
    listening: false,
  }),
  actions: {
    async fetch() {
      const { notifications, unreadCount } = await notificationsApi.list();
      this.items = notifications;
      this.unreadCount = unreadCount;
    },
    async markRead(id) {
      await notificationsApi.markRead(id);
      const item = this.items.find((n) => n._id === id);
      if (item && !item.read) {
        item.read = true;
        this.unreadCount = Math.max(0, this.unreadCount - 1);
      }
    },
    async markAllRead() {
      await notificationsApi.markAllRead();
      this.items.forEach((n) => { n.read = true; });
      this.unreadCount = 0;
    },
    listen() {
      const socket = getSocket();
      if (!socket || this.listening) return;
      this.listening = true;
      socket.on('notification', (notification) => {
        this.items.unshift(notification);
        this.unreadCount += 1;
      });
    },
  },
});
